export default {
  name: 'validations.attributes.name',
  givenName: 'validations.attributes.givenName',
  familyName: 'validations.attributes.familyName',
  email: 'validations.attributes.email',
  role: 'validations.attributes.role',
};
